import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { State } from '../../../../reducers';
import { actionsGUHorarios } from '../../../../actions/action-creators';
import { bindActionCreators } from 'redux';
import { FormHorario as FormHorarioI } from '../../../../interfaces/horario.interfaces';

export const FormHorario = () => {
  const dispatch = useDispatch();
  const actionsHorario = bindActionCreators(actionsGUHorarios, dispatch);
  const {selectedSucursal, formHorario, errorsHorario} = useSelector((state: State) => state.horarios);

  useEffect(() => {
    actionsHorario.gu_hs_handleErrorsFormHorario();
  }, [formHorario]);

  const validForm = useMemo(() => {
    for(const field in errorsHorario) {
      const key = field as keyof FormHorarioI;
      if (errorsHorario[key]) return true;
    }
    return false;
  }, [errorsHorario]);

  return(
    <>
      {selectedSucursal && 
      (
        <div className='container-white w-100'>
          <div className='client-tab-title'>
            <h3 className='card-title mb-16'>Actualizar horario - {selectedSucursal.nombre}</h3>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='mt-16'>
              <label className="w-checkbox">
                <input autoComplete='off' type="checkbox" checked={formHorario.sinHorario} onChange={() => actionsHorario.gu_hs_handleChangeFormHorario('sinHorario', !formHorario.sinHorario)} />
                <div className="checkbox__checkmark"></div>
                <div className="checkbox__body" style={{fontWeight: '400'}}>Sin limitación de horario</div>
              </label>
            </div>
          </div>
          <div className='w-layout-hflex h-inputs mt-16'>
            <div className='label-input'>
              <label htmlFor='horaInicio' className='field-label'>
                Horario de inicio
                {!formHorario.sinHorario && <span style={{color: 'red'}}>*</span>}
              </label>
              <input autoComplete="off"
                type='time'
                className='text-field w-input'
                name='horaInicio'
                placeholder='Horario de inicio'
                id='horaInicio'
                value={formHorario.horaInicio}
                disabled={formHorario.sinHorario}
                style={{minWidth: '180px'}}
                onChange={(e) => actionsHorario.gu_hs_handleChangeFormHorario('horaInicio', e.target.value)}
              />
              {errorsHorario.horaInicio && <p className='alert'>{errorsHorario.horaInicio}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='horaFin' className='field-label'>
                Horario de salida
                {!formHorario.sinHorario && <span style={{color: 'red'}}>*</span>}
              </label>
              <input autoComplete="off"
                type='time'
                className='text-field w-input'
                name='horaFin'
                placeholder='Horario de inicio'
                id='horaFin'
                value={formHorario.horaFin}
                disabled={formHorario.sinHorario}
                style={{minWidth: '180px'}}
                onChange={(e) => actionsHorario.gu_hs_handleChangeFormHorario('horaFin', e.target.value)}
              />
              {errorsHorario.horaFin && <p className='alert'>{errorsHorario.horaFin}</p>}
            </div>
          </div>
          <div className='mt-16' style={{justifyContent: 'end', display: 'flex'}}>
            <button onClick={actionsHorario.gu_hs_onClickSaveHorario} className="button w-auto" disabled={validForm}>
              Guardar horario
            </button>
          </div>
        </div>
      )}
    </>
  )
}